module.exports = __webpack_public_path__ + "static/media/bg_whats-on.c1eac6d3.jpg";